import { useNavigate } from "react-router-dom";
import { useEffect, ReactElement } from "react";
import routeConstants from "../utils/routeConstants";
import useAuth from "../hooks/useAuth";
import { AuthGuardProps } from "../types/AuthTypes";

const AuthGuard = ({ children }: AuthGuardProps): ReactElement | null => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(routeConstants.login);
    }
  }, [isAuthenticated, navigate]);

  // Prevent flash of content
  if (!isAuthenticated) {
    return null;
  }

  return children as ReactElement;
};

export default AuthGuard;
